const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://www.eraldc.com',
  title: 'Go.',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Erald Caka',
  location: 'Vancouver, Canada',
  role: 'Software Developer',
  description:
    'Im a backend-focused software engineer skilled in Golang, specializing in event-driven architectures, scalable microservices, and IoT development.',
  resume: 'https://example.com',
  social: {
    linkedin: 'https://www.linkedin.com/in/erald-caka',
    github: 'https://www.github.com/EraldCaka',
  },
}

const experience = [
  {
    company: 'Indra',
    role: 'Software Developer',
    description: 'Worked on several products for Minsait and Onesait.',
    responsibilities: [
      'Managed integration of IoT data ingestion across multiple services.',
      'Developed and scaled high-performance Golang applications to the industry best practices.',
      'Created microservices using event-driven design principles.',
      'Library development to communicate with the Iot devices',
      'SDK and CDK development.',
    ],
    iconUrl:
      'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.pta.es%2Fwp-content%2Fuploads%2F2020%2F04%2Flogotipo_indra.jpg&f=1&nofb=1&ipt=8bdb8b7f6791d0fca54a72003dd3599717d1cd83a013c800a4cf154aef751fc9&ipo=images',
    duration: 'Feb 2023 - Present',
    location: '',
    technologies: [
      'Golang',
      'Kafka',
      'Java',
      'Jenkins',
      'Yaml',
      'Shell',
      'Docker',
      'CI/CD',
      'Mqtt',
      'RabbitMQ',
      'Kubernetes',
      'Fiber',
      'Gin',
    ],
    companyUrl: 'https://www.indracompany.com',
    companyIcon: 'https://techcorp.com/logo.png',
  },
  {
    company: 'TeamSystem',
    role: 'Software Developer',
    description:
      'Worked on big telecommunicational products utilized by millions per day like Windtre, Vodafone, Mediaset, Tim and Leonardo.',
    responsibilities: [
      'Introduced the idea of Actor Model for better service to service communication in Golang.',
      'Created and optimized several services to speed up the processing time of bulk data by 53%',
      'Configured the Kafka broker for message delivery between services and logging.',
      `Lead the documentation of some of the products.`,
    ],
    iconUrl: '',
    duration: 'Feb 2021 - Jan 2023',
    location: '',
    technologies: [
      'Golang',
      'Java',
      'Docker',
      'React',
      'Yaml',
      'Kafka',
      'Fiber',
      'Gin',
      'Spring Boot',
    ],
    companyUrl: 'https://www.teamsystem.com',
  },
]

const education = [
  {
    institution: 'Empire State University',
    degree: 'B.Sc. Computer Science',
    description: 'Focused on distributed systems and backend development.',
    highlights: [
      '50% scholarship for the whole duration of my studies from the Empire State University.',
      'Dean’s List, Empire State University.',
      'Led a capstone project that developed a scalable microservices architecture for an e-commerce platform.',
    ],
    duration: '2020 - 2024',
    location: 'New York, NY',
    iconUrl: '',
    institutionUrl: 'https://university.example.edu',
    institutionIcon: 'https://university.example.edu/logo.png',
  },
  // {
  //   institution: 'Langara College',
  //   degree: 'M.Sc. Computer Science',
  //   description:
  //     'Gained foundational knowledge in programming and systems design.',
  //   highlights: [
  //     'Graduated with Honors',
  //     'Led a team project on IoT device connectivity',
  //   ],
  //   iconUrl: '',
  //   duration: '2024 - 2026',
  //   location: 'Vancouver, BC',
  //   institutionUrl: 'https://college.example.edu',
  //   institutionIcon: 'https://college.example.edu/logo.png',
  // },
]

const projects = [
  {
    name: 'GPIoT',
    description:
      'GPIoT is a service that utilizes the MQTT broker to enable real-time data transfer between a server and IoT devices like Raspberry Pi GPIO pins.It supports both digital and analog pins for various IoT projects.',
    stack: [
      'Go',
      'MQTT',
      'Event-Driven-Architecture',
      'Mosquitto',
      'Raspberry Pi',
      'GPIO',
      'IoT Development',
      'Docker',
    ],
    sourceCode: 'https://github.com/EraldCaka/GPIoT',
    livePreview: '',
  },
  {
    name: 'Broker',
    description:
      'An event-driven-architecture broker that is used just like Nginx for delivering messages to connected services.',
    stack: [
      'Go',
      'Docker',
      'Event-Driven-Architecture',
      'Watermill',
      'Fiber',
      'Apache Kafka',
    ],
    sourceCode: 'https://github.com/EraldCaka/broker',
    livePreview: '',
  },
  {
    name: 'Durazzo',
    description:
      'Blazingly Fast and easy to use orm library with basic crud operations and customizable raw queries for Go',
    stack: ['Go', 'PostgreSQL', 'MySQL', 'SQLite', 'CI/CD', 'Testing'],
    sourceCode: 'https://github.com/EraldCaka/durazzo',
    livePreview: '',
  },
  {
    name: 'Chat Room API',
    description:
      'An application that allows users to create and connect to online chatrooms with other users, built in Go.',
    stack: ['Go', 'Gin', 'Websockets', 'PostgreSQL', 'Testing'],
    sourceCode: 'https://github.com/EraldCaka/chat-room',
    livePreview: '',
  },
  {
    name: 'Chat Room Client',
    description:
      'An application that allows users to create and connect to online chatrooms with other users.',
    stack: ['React', 'Websockets', 'Typescript', 'Javascript', 'CSS'],
    sourceCode: 'https://github.com/EraldCaka/chat-room-client',
    livePreview: '',
  },
  {
    name: 'Prizz Backend',
    description:
      'A hackathon challenge to build an app for task management. Team effort project.',
    stack: ['Go', 'Fiber', 'Websockets', 'Docker', 'PostgreSQL'],
    sourceCode: 'https://github.com/Prizz-Squad/prizz-backend',
    livePreview: '',
  },
]

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'Go',
  'Fiber',
  'Docker',
  'Apache Kafka',
  'IoT Development',
  'Docker',
  'CI/CD',
  'MQTT',
  'TypeScript',
  'React',
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'eraldcaka47@gmail.com',
}

export { header, about, projects, skills, contact, education, experience }
